import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { Send, MessageCircle, Phone, Mail, MapPin } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      // Using Formspree - free service that sends form data to email
      // Replace 'YOUR_FORM_ID' with actual Formspree form ID after setup at formspree.io
      const response = await fetch('https://formspree.io/f/xanyqbke', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          phone: formState.phone,
          message: formState.message,
          _replyto: 'igorvyshnevyy@gmail.com',
          _subject: 'Нова заявка з сайту Військовий Адвокат'
        })
      });
      if (response.ok) {
        setIsSuccess(true);
        setFormState({
          name: '',
          phone: '',
          message: ''
        });
        setTimeout(() => setIsSuccess(false), 5000);
      } else {
        throw new Error('Failed to send');
      }
    } catch (err) {
      setError("Помилка відправки. Спробуйте ще раз або зв'яжіться напряму.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return <Section id="contact" background="gray" data-id="element-20">
      {/* Decorative pattern */}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-[0.02] pointer-events-none hidden lg:block" data-id="element-21">
        <div className="w-full h-full border-l border-b border-black" data-id="element-22"></div>
      </div>

      <div className="grid md:grid-cols-2 gap-12 lg:gap-24 relative z-10" data-id="element-23">
        <div data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-bold text-black mb-6 md:mb-8" data-id="element-25">
            Контакти
          </h2>
          <p className="text-neutral-500 mb-8 md:mb-12 text-base md:text-lg font-light max-w-md" data-id="element-26">
            Залиште заявку, і наш адвокат зв'яжеться з вами найближчим часом для
            аналізу вашої ситуації.
          </p>

          <div className="space-y-6 md:space-y-8 mb-8 md:mb-12" data-id="element-27">
            <div className="group" data-id="element-28">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-29">
                <Phone className="h-3 w-3" data-id="element-30" />
                Телефон
              </p>
              <a href="tel:+380633540689" className="text-xl md:text-2xl text-black hover:text-neutral-600 transition-colors block break-words" data-id="element-31">
                +380 63 354 06 89
              </a>
            </div>

            <div className="group" data-id="element-32">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-33">
                <Mail className="h-3 w-3" data-id="element-34" />
                Email
              </p>
              <a href="mailto:igorvyshnevyy@gmail.com" className="text-xl md:text-2xl text-black hover:text-neutral-600 transition-colors block break-all" data-id="element-35">
                igorvyshnevyy@gmail.com
              </a>
            </div>

            <div className="group" data-id="element-36">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-37">
                <MapPin className="h-3 w-3" data-id="element-38" />
                Офіс
              </p>
              <p className="text-xl md:text-2xl text-black" data-id="element-39">
                м. Київ, вул. Хрещатик, 1
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4" data-id="element-40">
            <Button variant="outline" className="flex-1 justify-between group text-sm md:text-base" onClick={() => window.open('https://t.me/GurinenkoKarina', '_blank')} data-id="element-41">
              <span data-id="element-42">Telegram</span>
              <Send className="h-4 w-4 text-neutral-400 group-hover:text-black group-hover:translate-x-1 transition-all" data-id="element-43" />
            </Button>
            <Button variant="outline" className="flex-1 justify-between group text-sm md:text-base" onClick={() => window.open('https://wa.me/380633540689', '_blank')} data-id="element-44">
              <span data-id="element-45">WhatsApp</span>
              <MessageCircle className="h-4 w-4 text-neutral-400 group-hover:text-black group-hover:scale-110 transition-all" data-id="element-46" />
            </Button>
          </div>
        </div>

        <div className="bg-white p-6 md:p-12 border border-neutral-200 relative overflow-hidden" data-id="element-47">
          {/* Decorative corner */}
          <div className="absolute top-0 right-0 w-16 md:w-24 h-16 md:h-24 border-l border-b border-neutral-100" data-id="element-48"></div>

          <h3 className="text-xl md:text-2xl font-bold text-black mb-6 md:mb-8" data-id="element-49">
            Форма зв'язку
          </h3>

          {isSuccess ? <div className="bg-neutral-50 border border-neutral-200 p-6 md:p-8 text-center h-full flex flex-col items-center justify-center min-h-[300px] md:min-h-[400px] animate-in fade-in zoom-in duration-500" data-id="element-50">
              <div className="h-12 w-12 bg-black rounded-full flex items-center justify-center mb-6 animate-in zoom-in duration-700 delay-200" data-id="element-51">
                <Send className="h-5 w-5 text-white" data-id="element-52" />
              </div>
              <h4 className="text-lg md:text-xl font-bold text-black mb-2" data-id="element-53">
                Заявку відправлено
              </h4>
              <p className="text-sm md:text-base text-neutral-500" data-id="element-54">
                Ми зв'яжемося з вами найближчим часом.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" data-id="element-55">
              <Input label="Ім'я" placeholder="Іван Петренко" value={formState.name} onChange={e => setFormState({
            ...formState,
            name: e.target.value
          })} required data-id="element-56" />
              <Input label="Телефон" type="tel" placeholder="+38 (0XX) XXX-XX-XX" value={formState.phone} onChange={e => setFormState({
            ...formState,
            phone: e.target.value
          })} required data-id="element-57" />
              <Textarea label="Повідомлення" placeholder="Опишіть вашу ситуацію..." value={formState.message} onChange={e => setFormState({
            ...formState,
            message: e.target.value
          })} required data-id="element-58" />
              {error && <p className="text-sm text-red-500" data-id="element-59">{error}</p>}
              <Button type="submit" className="w-full mt-4 group" size="lg" isLoading={isSubmitting} data-id="element-60">
                <span data-id="element-61">Відправити</span>
                <Send className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-62" />
              </Button>
              <p className="text-xs text-neutral-400 mt-4 md:mt-6" data-id="element-63">
                Натискаючи кнопку, ви погоджуєтесь на обробку персональних даних
              </p>
            </form>}
        </div>
      </div>
    </Section>;
}